import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

const primaryStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 170px;
  padding: 14px 22px;
  box-sizing: border-box;
  @media (max-width: 480px) { min-width: 0; width: 100%; }
  border: none;
  border-radius: 999px;
  background: var(--accent);
  color: #121214;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  cursor: pointer;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.32);
  &:hover { transform: translateY(-2px); box-shadow: 0 24px 60px rgba(0, 0, 0, 0.4); }
  &:disabled { opacity: 0.5; pointer-events: none; }
`;

const secondaryStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 170px;
  padding: 14px 22px;
  box-sizing: border-box;
  @media (max-width: 480px) { min-width: 0; width: 100%; }
  border-radius: 999px;
  border: 1px solid rgba(243, 239, 230, 0.16);
  background: transparent;
  color: var(--ink);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  cursor: pointer;
  transition: transform 0.22s ease, border-color 0.22s ease, background 0.22s ease;
  &:hover { transform: translateY(-2px); border-color: rgba(214, 179, 106, 0.48); background: rgba(255, 255, 255, 0.03); }
`;

/* Link variants (react-router) */
export const PrimaryButton = styled(Link)`${primaryStyles}`;
export const SecondaryButton = styled(Link)`${secondaryStyles}`;

/* Anchor variants (mailto, tel, external) */
export const PrimaryAnchor = styled.a`${primaryStyles}`;
export const SecondaryAnchor = styled.a`${secondaryStyles}`;

/* Native button variants (form submit, actions) */
export const PrimaryAction = styled.button`${primaryStyles}`;
export const SecondaryAction = styled.button`${secondaryStyles}`;
